module.exports = __webpack_public_path__ + "travel_white.svg?bc021902fc5ddcd1e90ca3292c3fedfa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/travel_white.svg
// module id = 141
// module chunks = 0